var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"servers",attrs:{"fluid":""}},[(_vm.user.id != -1)?_c('ServersTable',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }